import React from 'react'
import styled from 'styled-components'
import { Button, theme } from 'pcln-design-system'

const StyledButton = styled(Button)<{
  animatedBoxShadow: string
  scale: number
}>`
  &:hover {
    transform: scale(${props => props.scale});
    box-shadow: ${props => props.animatedBoxShadow};
    transition: 0.2s ease-in-out;
  }
`

function FindYourDealButton({
  currentProduct = '',
  formButtonProps,
  hasMinWidth,
  isLargeInput
}: {
  currentProduct: string
  formButtonProps?: any
  hasMinWidth?: boolean
  isLargeInput?: boolean
}) {
  const buttonText = `Find Your ${currentProduct
    .charAt(0)
    .toUpperCase()}${currentProduct.slice(1, -1)}`
  return (
    <StyledButton
      m={0}
      width={1}
      size="large"
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      scale={theme.scale['scale-100'] + theme.scale['scale-2']}
      animatedBoxShadow={theme.shadows.xl}
      style={{
        whiteSpace: 'nowrap',
        minWidth: hasMinWidth ? '165px' : null,
        height: isLargeInput ? '56px' : null
      }}
      {...formButtonProps}
    >
      {buttonText}
    </StyledButton>
  )
}

export default FindYourDealButton
